// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-control_width-auto {
  width: auto;
}
.conn-form-control_width-s {
  width: 90px;
}
.conn-form-control_width-m {
  width: 240px;
}
.conn-form-control_width-l {
  flex-grow: 1;
}
.conn-form-control__hint .yfm {
  margin-top: 2px;
}
.conn-form-control__hint .yfm p {
  color: var(--g-color-text-hint);
}
.conn-form-control .dl-field-wrapper__error-text {
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/components/withControlWrap/withControlWrap.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAGI;EACI,WAAA;AADR;AAII;EACI,YAAA;AAFR;AAKI;EACI,YAAA;AAHR;AAMI;EACI,eAAA;AAJR;AAMQ;EACI,+BAAA;AAJZ;AASI;EACI,mBAAA;AAPR","sourcesContent":[".conn-form-control_width-auto {\n  width: auto;\n}\n.conn-form-control_width-s {\n  width: 90px;\n}\n.conn-form-control_width-m {\n  width: 240px;\n}\n.conn-form-control_width-l {\n  flex-grow: 1;\n}\n.conn-form-control__hint .yfm {\n  margin-top: 2px;\n}\n.conn-form-control__hint .yfm p {\n  color: var(--g-color-text-hint);\n}\n.conn-form-control .dl-field-wrapper__error-text {\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
